export default {
  isLoading: false,
  accounts: [],
  contacts: [],
  leads: [],
  opportunities: [],
  activities: [],
  documents: [],
};
